// This is the base JS file loaded by the browser. It is responsible
// for making calls to initialize stores, loading resources, and
// ultimately telling React to start.

import 'isomorphic-fetch';
import 'app/less/main.less';

import Game from 'app/src/game/Game';
// import * as FontFaceObserver from 'fontfaceobserver';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

// Load fonts, then add a class to the body.
/*
// This is disabled because we're not currently using FontFaceObserver for any reason.
const fonts: [string, Record<string, any>?][] = [
	['Gill Sans', { weight: 'normal' }],
	['Gill Sans', { weight: 'normal', style: 'italic' }],
	['Gill Sans', { weight: 'lighter' }],
	['Gill Sans', { weight: 'lighter', style: 'italic' }],
	['Gill Sans', { weight: 'bold' }],
	['Gill Sans', { weight: 'bold', style: 'italic' }],
	['Digital-7'],
	['Open Sans'],
];
Promise.all(fonts.map(([name, options]) => new FontFaceObserver(name, options).load())).then(() => {
	document.body.classList.add('fonts-loaded');
});
*/

// Start the app.
ReactDOM.render(<Game />, document.getElementById('app'));
